import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Forgot from "../src/Component/Login/Forgot";
import Login from "../src/Component/Login/Login";
import Register from "../src/Component/Login/Register";
import Resetpassword from "../src/Component/Login/Resetpassword";
import CompanyProfile from "./Component/Admin/CompanyProfile/CompanyProfile";
import AdminParent from "./Component/Admin/DefaultPricing/AdminParent";
import Divisions from "./Component/Admin/Divisions/Divisions";
import Employee from "./Component/Admin/Employee/Employee";
import AdminRole from "./Component/Admin/RoleManagement/AdminRole/AdminRole";
import UserRole from "./Component/Admin/RoleManagement/UserRole/UserRole";
import Users from "./Component/Admin/Users/Users";
import Vehicle from "./Component/Admin/Vehicle/Vehicle";
import AccountEnquiry from "./Component/AR/AccountEnquiry/AccountEnquiry";
import AgedReceivableReport from "./Component/AR/AgedReceivableReport/AgedReceivableReport";
import DepostDistribution from "./Component/AR/DepositDistribution/DepositDistribution";
import EnterABankDeposit from "./Component/AR/EnterABankDeposit/EnterAbankDeposit";
import MonthlySales from "./Component/AR/MonthlySales/MonthlySales";
import ProcessCustomerInvoice from "./Component/Billing/ProcessCutomerInvoice";
import Customer from "./Component/Customer/Customer";
import HistoryManagement from "./Component/Customer/HistoryManagement/HistoryManagement";
import Dashboard from "./Component/Dashboard/Dashboard";
import AceCommunications from "./Component/Dispatch/ACECommunication/AceCommunication";
import Acicommunicator from "./Component/Dispatch/AciCommunicator/AciCommunicator";
import CustomBrokerList from "./Component/Dispatch/CustomBrokerList/CustomBrokerList";
import Interliners from "./Component/Dispatch/Interliners/Interliners";
import ProcessPrebookedOrders from "./Component/Dispatch/ProcessPrebookedOrders/ProcessPrebookedOrders";
import LocalDispatch from "./Component/Dispatch/SamedayDispatch/Dispatch";
import TripControlSystem from "./Component/Dispatch/TripControlSystem/TripControlSystem";
import TripDispatch from "./Component/Dispatch/TripDispatch/TripDispatch";
import Layout from "./Component/Layout";
import AppointmentDesk from "./Component/Order/Appointmentdesk/AppointmentDesk";
import OrderMaintenance from "./Component/Order/OrderMaintenance/OrderMaintenance";
import OrdersMap from "./Component/Order/OrdersMap/OrdersMap";
import Order from "./Component/Order/OrderTaking/Order";
import OrderTracing from "./Component/Order/OrderTracing/Ordertracing";
import UploadOrderList from "./Component/Order/UploadOrderList/UploadOrderList";
import ProcessPayroll from "./Component/Payroll/ProcessPayroll/ProcessPayroll";
import TripControlPayroll from "./Component/Payroll/TripControlPayroll/TripControlPayroll";
import DetailedExcelReport from "./Component/Report/DetailedExcelReport/DetailedExcelReport";
import SalesCalender from "./Component/Report/SalesCalender/SalesCalender";
import VerifyOrderModification from "./Component/Report/VerifyOrderModifications/VerifyOrderModification";
import RequireAuth from "./Component/RequireAuth";
import { CreateCustomer } from "./context/CustomerContext";
import { logout, setCredentials } from "./features/auth/authSlice";
import Design from "./Component/designSystem/Design";

const App = () => {
  const dispatch = useDispatch()
  const [ready, setReady] = useState(false)

  // Hydrate Redux from localStorage exactly once on app startup
  useEffect(() => {
    const token = localStorage.getItem('token')
    const emailId = localStorage.getItem('emailId')
    if (token && emailId) {
      dispatch(setCredentials({ data: { token, emailId } }))
    } else {
      dispatch(logout())
    }
    setReady(true)
  }, [dispatch])

  // Don’t render your routes until hydration is done
  if (!ready) return null

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route exact path="login" element={<Login />} />
            <Route exact path="register" element={<Register />} />
            <Route exact path="forgot" element={<Forgot />} />
            <Route exact path="reset" element={<Resetpassword />} />
            <Route exact path="design" element={<div style={{ display: "grid", placeItems: "center", height: "100vh" }}><Design /></div>} />
            <Route element={<RequireAuth />}>

              <Route exact index element={<Dashboard />} />

              <Route exact path="/AR/enter-a-bank-deposit" element={<EnterABankDeposit />} />
              <Route exact path="/AR/account-enquiry" element={<AccountEnquiry />} />
              <Route exact path="/AR/monthly-sales-Billing-Totals" element={<MonthlySales />} />
              <Route exact path="/AR/AG-aged-receivable-report" element={<AgedReceivableReport />} />
              <Route exact path="/AR/deposit" element={<DepostDistribution />} />

              <Route exact path="/billing/processcustomerinvoice" element={<ProcessCustomerInvoice />}></Route>

              <Route exact path="/customer/CustomerCrud" element={<Customer />}></Route>
              <Route exact path="/customer/history-management" element={<HistoryManagement />}></Route>

              <Route exact path="/dispatch/process-prebooked-order" element={<ProcessPrebookedOrders />}></Route>
              <Route exact path="/dispatch/trip-control" element={<TripControlSystem />}></Route>
              <Route exact path="/dispatch/ace-communication" element={<AceCommunications />}></Route>
              <Route exact path="/dispatch/custom-broker-list" element={<CustomBrokerList />}></Route>
              <Route exact path="/dispatch/trip-dispatch" element={<TripDispatch />} />
              <Route exact path="/dispatch/aci-communicator" element={<Acicommunicator />}></Route>
              <Route exact path="/dispatch/same-day-dispatch" element={<LocalDispatch />} />
              <Route exact path="/dispatch/agents-interliners" element={<Interliners />}></Route>

              <Route exact path="/report/verify-order-modification" element={<VerifyOrderModification />} />
              <Route exact path="/report/detailed-excel-report" element={<DetailedExcelReport />} />
              <Route exact path="/report/sales-calender" element={<SalesCalender />} />

              <Route exact path="/order/order-maintenance" element={<OrderMaintenance />} />
              <Route exact path="/order/order-tracking" element={<OrderTracing />} />
              <Route exact path="/order/appointment-desk" element={<AppointmentDesk />} />
              <Route exact path="/order/order-taking-by-telephone" element={<Order />} />
              <Route exact path="/order/upload-order" element={<UploadOrderList />} />

              <Route exact path="/admin/company-profile" element={<CreateCustomer> <CompanyProfile /></CreateCustomer>}></Route>
              <Route exact path="/admin/users" element={<Users />}></Route>
              <Route exact path="/admin/vehicle" element={<Vehicle />}></Route>
              <Route exact path="/admin/employee" element={<Employee />}></Route>
              <Route exact path="/admin/default-pricing" element={<AdminParent />}></Route>
              <Route exact path="/admin/divisions" element={<Divisions />}></Route>
              <Route exact path="/payroll/process-payroll" element={<ProcessPayroll />}></Route>
              <Route exact path="/payroll/trip-control-payroll" element={<TripControlPayroll />}></Route>
              <Route exact path="/role-management/admin-role/" element={<AdminRole />}></Route>
              <Route exact path="/role-management/user-role" element={<UserRole />}></Route>
              <Route exact path="/map" element={<OrdersMap />}></Route>
            </Route>

          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export default App;
